// ApexCharts (3.53) no dibuja nada en un gráfico de líneas cuando ninguna
// serie tiene dos puntos seguidos (por ejemplo, una sola fecha con datos): el
// tooltip muestra el valor pero el gráfico queda vacío. Las series sin ningún
// tramo se dibujan como puntos (scatter) y el resto sigue como líneas.

const valueOf = (point: unknown) =>
  point && typeof point === 'object' ? (point as { y?: unknown }).y : point;

export const hasSegment = (data: unknown[]) =>
  data.some(
    (point, i) =>
      i > 0 && valueOf(point) != null && valueOf(data[i - 1]) != null
  );

export function showIsolatedPoints<T extends { data: unknown[] }>(
  series: T[]
): (Omit<T, 'type'> & { type?: string })[] {
  return series.map((serie) =>
    hasSegment(serie.data ?? []) ? serie : { ...serie, type: 'scatter' }
  );
}

/**
 * Sombra solo en las series que siguen como líneas. Si no queda ninguna se
 * apaga: con enabledOnSeries vacío ApexCharts la aplica a todas.
 */
export const lineShadow = (series: { type?: string }[]) => {
  const lines = series.flatMap((serie, i) =>
    serie.type === 'scatter' ? [] : [i]
  );
  return { enabled: lines.length > 0, enabledOnSeries: lines };
};
